module.exports = __webpack_public_path__ + "static/media/Gradien Mediatama.8f284926.jpg";